import { Loader2 } from "lucide-react";

export function FileExplorerLoadingState() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <Loader2 className="h-8 w-8 animate-spin text-imperial-600" />
      <p className="text-sm text-ink-600">Loading category...</p>
    </div>
  );
}

